import { Container } from "./styles";

import linkedinIcon from "../../assets/footer/linkedin.png";
import githubIcon from "../../assets/footer/github.png";
import instagramIcon from "../../assets/footer/instagram.png";
import twitterIcon from "../../assets/footer/twitterIcon.png";
import devIcon from "../../assets/footer/dev-icon.png";

export function Footer() {
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>T</span>
        <span>angled</span>
      </a>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/freedan-jeremiah-b51887226/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedinIcon} alt="Linkedin" />
        </a>

        <a
          href="https://devpost.com/freedanjeremiah-25it?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav"
          target="_blank"
          rel="noreferrer"
        >
          <img src={devIcon} alt="DevTo" />
        </a>

        <a
          href="https://twitter.com/settings/account?lang=en"
          target="_blank"
          rel="noreferrer"
        >
          <img src={twitterIcon} alt="Twitter" />
        </a>

        <a
          href="https://github.com/Wonderwisse"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>

        <a
          href="https://www.instagram.com/freedanjeremiah/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
    </Container>
  );
}
